<template>
  <MUIDialog
    :class="classNames"
    :displayType="displayType"
    :navItem="navItem"
    :style="styles"
    ref="dialog">
    <progressive-img
      :src="temporaryViewProps.url"
      :placeholder="temporaryViewProps.placeholder"
      :aspect-ratio="invertedAspectRatio"
      @onLoadPlaceholder="onLoadPlaceholder" />
  </MUIDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  MUIDialog
} from '../components'

import { CONTEXT } from '../config'

export default {
  components: {
    MUIDialog
  },
  computed: {
    ...mapGetters([
      'temporaryViewProps'
    ]),
    aspectRatio () {
      return this.temporaryViewProps.width / this.temporaryViewProps.height
    },
    invertedAspectRatio () {
      return 1 / this.aspectRatio
    },
    maxHeight () {
      return Math.min(
        this.temporaryViewProps.height,
        this.$store.state.device.innerHeight - 80
      )
    },
    maxWidth () {
      return Math.min(
        this.temporaryViewProps.width,
        this.$store.state.device.innerWidth - 240
      )
    },
    resizeHeightRatio () {
      return this.maxHeight / this.temporaryViewProps.height
    },
    resizeWidthRatio () {
      return this.maxWidth / this.temporaryViewProps.width
    },
    resizeRatio () {
      if (this.aspectRatio > 1) {
        // Landscape
        return this.resizeWidthRatio
      } else if (this.aspectRatio < 1) {
        // Portrait
        return this.resizeHeightRatio
      } else {
        // Square
        return (this.$store.state.device.orientation === 'landscape')
          ? this.resizeHeightRatio
          : this.resizeWidthRatio
      }
    },
    classNames () {
      return {
        'mui-dialog--image': true,
        'mui-dialog--loading': this.loading
      }
    },
    styles () {
      return {
        height: `${this.temporaryViewProps.height * this.resizeRatio}px`,
        width: `${this.temporaryViewProps.width * this.resizeRatio}px`
      }
    }
  },
  data () {
    return {
      displayType: CONTEXT,
      loading: true,
      navItem: {
        icon: 'close',
        name: 'Cancel',
        fn: () => { this.$refs.dialog.close() }
      }
    }
  },
  methods: {
    onLoadPlaceholder () {
      this.loading = false
    }
  }
}
</script>

<style lang="sass">
.mui-dialog--image
  background: none
  width: auto
  max-width: none
  .mui-dialog__header
    position: absolute
    background: transparent
    border-bottom: none
    color: white
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.24)
    .mui-toolbar__nav
      margin-left: -7px
  .mui-dialog__actions
    display: none
  .mui-dialog__body
    display: block
    padding: 0
    z-index: -1
    img
      border-radius: 3px
      width: 100%
      height: 100%
  &.mui-dialog--loading
    visibility: hidden
</style>



// WEBPACK FOOTER //
// src/views/ImageDialog.vue